<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Filters</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <div class="p-6">
      <vs-row > 
        <vs-col v-if="!partner_namespace" vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Partner</label>
          <v-select
            @input="onPartnerChange"
            v-model="form.partner_id"
            :options="partners"
            :reduce="el => el.id" label="name"  />
        </vs-col> 
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px; display:none;">
          <label class="vs-input--label">Driver</label>
          <v-select
            :disabled="!form.partner_id"
            v-model="form.driver_id"
            :options="drivers"
            :reduce="el => el.id" :get-option-label="(option)=>{ return `${option.firstname} ${option.lastname}`}" label="name"  />
        </vs-col>
      </vs-row>
    </div>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submit" >Apply</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
  import {mapMutations, mapState, mapActions} from 'vuex'; 
  import {cloneDeep} from 'lodash'
import { clone } from '@amcharts/amcharts4/.internal/core/utils/Object';
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      default:{
        type: Object,

      },
      value:{
        type: Object
      }
    },
    components: {

    },
    data () {
      return {
        reloadvalue:false,
        form : {

        },
        partners : [], 
        drivers : [], 
      }
    },
    computed: {
      ...mapState(['partner_namespace']),
      isSidebarActiveLocal: {
        get () { if(this.isSidebarActive){ 

            if(!this.reloadvalue){
              this.reloadvalue=true;
             this.initialData(); 
            }
          }
          return this.isSidebarActive
        },
        set (val) {
          if (!val) {
            this.reloadvalue=false;
            this.$emit('closeSidebar')
            // this.$validator.reset()
            // this.initValues()
          }
        }
      },
      ...mapState('trips',['filters']),
      formattedFilters(){
        let payload = {};
        for(let item in this.$route.query){
            switch (item) { 
              case 'partner_id':
                let partner = this.partners.find(el => el.id === this.$route.query[item]);
                if(partner){
                  payload[item] = {
                    field : 'Partner',
                    value: this.$route.query[item],
                    text : partner.name
                  };
                }
                break; 
              case 'driver_id':
                let driver = this.drivers.find(el => el.id === this.$route.query[item]);
                if(driver){
                  payload[item] = {
                    field : 'Driver',
                    value: this.$route.query[item],
                    text : `${driver.firstname} ${driver.lastname}`
                  };
                }
                break;

            }
        }
        this.$emit('input', payload);
        return payload;
      },
    },
    watch: {
      filters(newValue, oldValue){
        let form = {};
        for(let key in newValue){
          form[key] = newValue[key].value;
        }
        this.form = form;
      },
      default(newValue, oldValue){
        this.form = newValue;
        this.submit();
      },
      formattedFilters(newValue, oldValue){
        this.$emit('input', newValue);
        //this.SET_FILTERS(newValue);
      }
    },
    created() {

    },
    mounted(){
      this.form = {...this.$route.query};
     // this.initialData();
    },
    methods: { 
      ...mapActions('partners',['fetchPartners']), 
      ...mapActions('drivers',['fetchDrivers']), 
      ...mapMutations('drivers',['SET_FILTERS']),
      initialData(){
        if(!this.partner_namespace){ 
          this.fetchPartners({limit: 500}).then(data=>{
            this.partners = _.cloneDeep(data.data.partners);
            if(this.form.partner_id){
              this.onPartnerChange(false, false);
            }
          });
        }
      },
 
      onPartnerChange(resetDriver = true, resetVehicle=true){
        this.vehicles = [];
        this.drivers = [];
        if (resetDriver) delete this.form.driver_id; 
        this.fetchDrivers({limit: 1000, partner_id: this.form.partner_id}).then(data=>{
          this.drivers = _.cloneDeep(data.drivers);
        });
      },
      submit () {
        let payload = {};
        for(let item in this.form){
          if(this.form[item]){
            switch (item) { 
              case 'partner_id':
                if(!this.partner_namespace){
                  payload[item] = {
                    field : 'Partner',
                    value: this.form[item],
                    text : (this.partners.find(el => el.id === this.form[item])).name
                  };
                }
                break; 
              case 'driver_id':
                let driver = this.drivers.find(el => el.id === this.form[item]);
                payload[item] = {
                  field : 'Driver',
                  value: this.form[item],
                  text : `${driver.firstname} ${driver.lastname}`
                };
                break;

            }
          }

        }
        this.isSidebarActiveLocal = false;
        this.$emit('submit', payload);
        this.SET_FILTERS(payload);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
